<template>
    <component :is="embedded ? 'div' : 'MainLayout'">
        <div class="container">
            <div class="box">
                <b-button v-if="$hasPermission('stopSale.add')" class="float-right" @click="newModel">Nuevo cierre de venta</b-button>
                <hr>
                <b-form @submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'stop-sales-index-list') }">
                    <div class="row pb-3">
                        <b-form-group class="col-2" label="Buscar">
                            <b-form-input v-model="filters.search" type="text" />
                        </b-form-group>
                        <b-form-group class="col-2" label="Vigencia">
                            <b-form-select v-model="filters.vigency" :options="vigencyOpts" />
                        </b-form-group>
                        <b-form-group class="col-3" label="Área de operación">
                            <b-form-select v-model="filters.zonedAreaId" :options="zonedAreaOpts" />
                        </b-form-group>
                        <b-form-group class="col-3" label="Categoría de servicio">
                            <b-form-select v-model="filters.serviceTypeCategoryId" :options="serviceCategoriesOpts" />
                        </b-form-group>
                        <b-form-group class="col-2" label=".">
                            <b-button type="submit" variant="primary">Buscar</b-button>
                        </b-form-group>
                    </div>
                </b-form>
                <AjaxTable
                    permission-show="stopSale.show"
                    id="stop-sales-index-list"
                    :columns="modelColumns"
                    :filters="filters"
                    resource="stop-sales"
                >
                    <template #cell(zonedArea)="row">
                        <div v-if="row.item.zonedArea">
                            <div>{{ row.item.zonedArea.name }}</div>
                            <div v-if="row.item.zones && row.item.zones.length">
                                <b-badge v-for="z in row.item.zones" :key="z.id" variant="light" class="mr-1 border">{{ z.name }}</b-badge>
                            </div>
                            <small v-else class="text-muted">Todas las zonas</small>
                        </div>
                        <span v-else class="text-muted">Todas las áreas</span>
                    </template>
                    <template #cell(serviceTypeCategories)="row">
                        <span v-if="row.item.serviceTypeCategories && row.item.serviceTypeCategories.length">
                            <b-badge v-for="cat in row.item.serviceTypeCategories" :key="cat.id" variant="secondary" class="mr-1">{{ cat.name }}</b-badge>
                        </span>
                        <span v-else class="text-muted">Todas</span>
                    </template>
                    <template #cell(dates)="row">
                        <div v-for="(date, i) in row.item.dates" :key="i">
                            <small>{{ date.startDateH }} → {{ date.endDateH }}</small>
                        </div>
                    </template>
                    <template #cell(actions)="row">
                        <div class="text-center">
                            <b-button @click="editModel(row.item.id)" type="button" size="sm" class="mr-1" variant="info">
                                <md-icon icon="edit" />
                            </b-button>
                            <b-button v-if="$hasPermission('stopSale.delete')" @click="modelDelete(row.item)" type="button" size="sm" class="mr-1" variant="danger">
                                <md-icon icon="delete" />
                            </b-button>
                        </div>
                    </template>
                </AjaxTable>
            </div>
        </div>
        <Single :unableEdit.sync="unableEdit" ref="single" :success-callback="successCallback" />
    </component>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'
import api from '../../../api.js'

export default {
    components: { MainLayout, AjaxTable, Single },
    props: {
        embedded: { type: Boolean, default: false },
    },
    data() {
        return {
            unableEdit: false,
            filters: {
                search:                '',
                vigency:               'current',
                zonedAreaId:           null,
                serviceTypeCategoryId: null,
            },
            modelColumns: [
                { key: 'id',                    label: 'ID' },
                { key: 'description',           label: 'Descripción' },
                { key: 'zonedArea',             label: 'Área / Zonas' },
                { key: 'serviceTypeCategories', label: 'Categorías' },
                { key: 'dates',                 label: 'Fechas' },
                { key: 'status',                label: 'Estatus' },
                { key: 'actions',               label: 'Acciones' },
            ],
        }
    },
    computed: {
        vigencyOpts() {
            return [
                { value: 'current',  text: 'Vigentes' },
                { value: 'expired',  text: 'Caducados' },
                { value: 'to_apply', text: 'Por aplicar' },
                { value: '',         text: 'Todos' },
            ]
        },
        zonedAreaOpts() {
            return [
                { value: null, text: 'Todas' },
                ...this.$root.auxVars.masterZonedAreasOpts.map(m => ({ value: m.id, text: m.name }))
            ]
        },
        serviceCategoriesOpts() {
            return [
                { value: null, text: 'Todas' },
                ...this.$root.auxVars.serviceTypesCategoriesOpts.map(c => ({ value: c.id, text: c.name }))
            ]
        },
    },
    methods: {
        successCallback() {
            this.$root.$emit('bv::refresh::table', 'stop-sales-index-list')
        },
        editModel(id) {
            this.unableEdit = !this.$hasPermission('stopSale.edit')
            this.$refs['single'].loadModel(id)
        },
        newModel() {
            this.unableEdit = false
            this.$refs['single'].loadModel(-1)
        },
        modelDelete(item) {
            this.$root.showWarning({
                okAction: (_event, setLoading, close) => {
                    setLoading(true)
                    api(this).delete(`/stop-sales/${item.id}`).then((response) => {
                        if (response.data.error) {
                            this.$root.showAlert(response.data.error, { variant: 'warning' })
                            close()
                            return
                        }
                        this.$root.showAlert('Registro eliminado!', { variant: 'warning' })
                        this.$root.$emit('bv::refresh::table', 'stop-sales-index-list')
                        close()
                    }).catch(err => {
                        this.$root.handleRequestError(err)
                        close()
                    })
                }
            })
        },
    },
    mounted() {
        this.$root.auxVars.loadResourcesOpts({
            vm: this,
            resourceNames: ['masterZonedAreasOpts', 'serviceTypesCategories', 'salesChannelsOpts'],
        })
    },
}
</script>
